import React from 'react';
import { withStyles } from '@mui/styles';
import { Tab, Tabs } from '@mui/material';

export const StyledTabs = withStyles(() => {
  return ({
    indicator: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      indicatorColor: '#45BF9F',
      color: 'gray',
      "& > span": {
        maxWidth: 107,
        width: "100%",
        backgroundColor: '#45BF9F',
      },
    },
  })
})((props) => <Tabs {...props} style={{ background: "white" }} TabIndicatorProps={{ children: <span /> }} />);

export const StyledTabsVertical = withStyles(() => {
  return ({
    indicator: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      indicatorColor: '#45BF9F',
      color: 'gray',
      "& > span": {
        maxWidth: 107,
        width: "100%",
        backgroundColor: '#45BF9F',
      },
    },
  })
})((props) => <Tabs orientation='vertical' {...props} style={{ background: "white", height: '100%' }} TabIndicatorProps={{ children: <span /> }} />);


export const StyledTab = withStyles((theme) => {
  return ({
    root: {
      textTransform: "none",
      minWidth: 40,
      color: '#424242',
      fontSize: '16px',
      // fontWeight: 500,
      fontFamily: `'Lato', sans-serif`,
      marginLeft: "20px",
      opacity: 0.5,
      marginRight: '10px',
      "&:focus": {
        opacity: 1,
        color: '#45BF9F',
      },
    },
  })
})((props) => <Tab {...props} style={{...props.style}} />);

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}